// extracted by mini-css-extract-plugin
module.exports = {"base":"MissingContentWarning_base__JgjOm"};